import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export abstract class BaseApiService {

  protected baseUrl = environment.api.baseUrl;


  constructor(protected http: HttpClient) {

  }

}
